import { render, staticRenderFns } from "./ChildrenDetail.vue?vue&type=template&id=25d52359&scoped=true&"
import script from "./ChildrenDetail.vue?vue&type=script&lang=js&"
export * from "./ChildrenDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenDetail.vue?vue&type=style&index=0&id=25d52359&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d52359",
  null
  
)

export default component.exports